import ApplicationModules from './ApplicationModules';
import PrintReferralDetail from './Print';

export default ApplicationModules;
export { PrintReferralDetail };
